import vue from "vue";

export default {
  update: form => vue.axios.put("/api/profile", { ...form }),

  update_address: ( form, profile_id )=> vue.axios.patch(`api/profile/${profile_id}/update_address`, { form} )
  .then((result) => {
    return result
  }).catch((err) => {
    return err    
  })
};
